import React from 'react'

export default function Home_mobile() {
  return (
    <>
      <div>home_mobile</div>
    </>
  )
}